import StorefrontIcon from '@mui/icons-material/Storefront';
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DeliveryService } from '../services/deliveryService';

interface Props {
  erro?: string;
}

export default function EntryPage({ erro }: Props) {
  const navigate = useNavigate();
  const [slug, setSlug] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erroLocal, setErroLocal] = useState('');

  async function entrar() {
    const valor = slug.trim().toLowerCase();
    if (!valor) { setErroLocal('Informe o endereço do estabelecimento.'); return; }
    setCarregando(true);
    setErroLocal('');
    try {
      sessionStorage.setItem('X-S', valor);
      const lista = await DeliveryService.listarUnidades();
      if (!lista || lista.length === 0) {
        setErroLocal('Estabelecimento não encontrado ou sem unidades ativas.');
        sessionStorage.removeItem('X-S');
      } else {
        navigate(`/${valor}`);
      }
    } catch {
      setErroLocal('Estabelecimento não encontrado. Verifique o endereço e tente novamente.');
      sessionStorage.removeItem('X-S');
    } finally {
      setCarregando(false);
    }
  }

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      px={3}
      bgcolor="background.default"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={3}
        width="100%"
        maxWidth={400}
      >
        <Box
          sx={{
            width: 72, height: 72, borderRadius: '50%',
            bgcolor: 'primary.main', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}
        >
          <StorefrontIcon sx={{ fontSize: 40, color: 'primary.contrastText' }} />
        </Box>

        <Box textAlign="center">
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Delivery Online
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Digite o endereço do estabelecimento para ver o cardápio e fazer seu pedido.
          </Typography>
        </Box>

        {(erro || erroLocal) && (
          <Box
            sx={{
              bgcolor: 'error.light', color: 'error.contrastText',
              borderRadius: 2, px: 2, py: 1.5, width: '100%',
            }}
          >
            <Typography variant="body2">{erroLocal || erro}</Typography>
          </Box>
        )}

        <TextField
          label="Endereço do estabelecimento"
          placeholder="ex: minha-loja"
          fullWidth
          value={slug}
          onChange={(e) => { setSlug(e.target.value); setErroLocal(''); }}
          onKeyDown={(e) => { if (e.key === 'Enter') entrar(); }}
          error={!!erroLocal}
          helperText={erroLocal ? undefined : 'Peça ao estabelecimento o endereço de acesso'}
          disabled={carregando}
          autoFocus
          slotProps={{
            input: {
              startAdornment: (
                <Typography variant="body2" color="text.disabled" sx={{ mr: 0.5, userSelect: 'none' }}>
                  delivery/
                </Typography>
              ),
            },
          }}
        />

        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={entrar}
          disabled={carregando || !slug.trim()}
          sx={{ py: 1.5, fontSize: '1rem', borderRadius: 3 }}
        >
          {carregando ? <CircularProgress size={22} color="inherit" /> : 'Acessar Delivery'}
        </Button>
      </Box>

      <Box
        component="footer"
        sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, py: 1.5, textAlign: 'center' }}
      >
        <Typography variant="caption" color="text.disabled">
          Powered by{' '}
          <Box component="span" fontWeight={700} color="text.secondary">
            Codesh Tecnologia
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
